export interface Pixel {
  url: string;
  dataMessageId: string;
  platformThreadId: string;
}

export interface FailedPixel extends Omit<Pixel, "url"> {
  code: number | string;
  message: string;
}
